let science_swiper = new Swiper(".science-list_slider", {
  speed: 400,
  freeMode: {
    momentum: false,
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true
  },
  slidesPerView: 0.7,
  spaceBetween: 10,
  // Responsive breakpoints
  breakpoints: {
    500: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    1250: {
      slidesPerView: 2,
      spaceBetween: 20
    }
  }
});
